export const HEADER_HEIGHT = 42;

/**
 * How far page content may stretch before it stops growing and centres itself in the space left.
 *
 * Without a cap, a wide monitor drags a table's last column to the far screen edge, and with the
 * agent chat open the content stays pinned to the left with a gulf between it and the chat.
 * Individual pages must not pick their own number: one width is what makes navigating between
 * them feel like one app.
 */
export const PAGE_CONTENT_MAX_WIDTH = 1500;
